module.exports = {"name":"gammaHeader","meta":{"description":"Replaces the existing header with the Gamma header","link":"https://trello.com/b/baVMdrJC/gamma-embedded-header-feedback"},"audiences":["allMembers"],"defaults":{"enabled":false},"defaultWeight":1,"experimentAllocation":0,"experimentVersion":"v1","variations":[{"name":"enabled","weight":1,"values":{"enabled":true}}],"autoTrack":true}


//////////////////
// WEBPACK FOOTER
// ./app/common/lib/experiments/config/gammaHeader.json
// module id = KAnv
// module chunks = 13